var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 27,
    viewBox: "0 0 36 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6254 0C34.4535 0 36.0004 1.54688 36.0004 3.375V23.625C36.0004 25.5234 34.4535 27 32.6254 27H3.37539C1.47695 27 0.000391006 25.5234 0.000391006 23.625V3.375C0.000391006 1.54688 1.47695 0 3.37539 0H32.6254ZM32.6254 3.375H3.37539V6.25781C4.92227 7.59375 7.45352 9.5625 12.7973 13.7812C13.9926 14.6953 16.3129 16.9453 18.0004 16.875C19.6176 16.9453 21.9379 14.6953 23.1332 13.7812C28.477 9.5625 31.0082 7.59375 32.6254 6.25781V3.375ZM3.37539 23.625H32.6254V10.6172C31.0082 11.8828 28.6879 13.7109 25.2426 16.4531C23.6254 17.6484 20.9535 20.3203 18.0004 20.25C14.977 20.3203 12.2348 17.6484 10.6879 16.4531C7.24258 13.7109 4.92227 11.8828 3.37539 10.6172V23.625Z",
    fill: "#189BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEmail);
export default __webpack_public_path__ + "static/media/blue-email.41be12bd32d42e1ff02159159843cc5e.svg";
export { ForwardRef as ReactComponent };